
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[...editorial]",
      function () {
        return require("private-next-pages/[...editorial].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[...editorial]"])
      });
    }
  